import type { Section } from './constants';
import { SECTIONS } from './constants';
import type { IPathInfo } from './types';

/**
 * Parse the pathname into a more usable format.
 * Example URLs:
 * - /mood-log-entry/step1
 * - /mood-log-entry/step2
 * - /mood-log-entry/completed
 * - /home/calendar
 * - /home/log
 * - /patches
 * - /profile
 * @param pathname - The pathname to parse.
 * @returns The parsed pathname.
 */
export const parsePathname = (pathname: string): IPathInfo => {
  // Trim the leading and trailing slashes and remove any extra slashes
  pathname = pathname.trim().replace(/^\/+|\/+$/g, '');

  const segments = pathname.split('/');
  const segmentWithStepNumber = segments.find((segment) => segment.startsWith('step'));

  let section: Section;
  if (segments[0] === '') {
    section = SECTIONS.Welcome;
  } else if (Object.values(SECTIONS).includes(segments[0] as Section)) {
    section = segments[0] as Section;
  } else {
    section = SECTIONS.Unknown;
  }

  const hasSteps = !!segmentWithStepNumber;
  return {
    section,
    segments,
    stepNumber: hasSteps ? parseInt(segmentWithStepNumber.replace(/\D/g, ''), 10) : null,
  };
};

/*
 * Checks if browser supports View Transitions API.
 */
export const supportsViewTransitions = () => {
  return typeof window !== 'undefined' && 'startViewTransition' in document;
};
